const LobbyTypeEnum = {
  'livecasino': 1,
  'casino-lobby': 2,
  'tvgames-lobby': 3,
  'virtualsport-lobby': 4,
  'fastgames-lobby': 5,
}
export const LobbyDemoPages = ['casino', 'casino-lobby', 'tvgames-lobby', 'virtualsport-lobby', 'fastgames-lobby'];

export const LobbyPages = {
  LiveCasino: 'livecasino',
  Casino: 'casino',
  CasinoLobby:'casino-lobby',
  Tvgames: 'tvgames-lobby',
  VirtualSport: 'virtualsport-lobby',
  FastGames: 'fastgames-lobby',
};

export const LobbyTranslationKeys = {
  'livecasino': 'liveCasino',
  'casino': 'casino',
  'casino-lobby':  'casino',
  'tvgames-lobby': 'tvGames',
  'virtualsport-lobby': 'virtualSport',
  'fastgames-lobby': 'virtualSport',
};

export const LobbyWidgetTypeEnum = {
  DailyTopWinners: 1,
  MonthlyTopWinners: 2,
  MyTopWinners: 3,
  MostLiked: 4,
  Jackpot: 5
}

export const LobbyNamesMapping = {
  1: 'liveCasino',
  4: 'casino-lobby',
  2: 'virtualsport-lobby',
  6: 'tvgames-lobby',
  3: 'fastgames-lobby'
};

export const LobbyTranslationsKeysMapping = {
  1: 'liveCasinoLobby',
  4: 'casinoLobby',
  2: 'virtualSportLobby',
  6: 'tvGamesLobby',
  5: 'otherText',
  3: 'fastGamesLobby'
};

export const LobbyGameTitleHoverEnum = {
  "GameName": 1,
  "ProviderName": 2
}

export const LobbySearchType = {
  'Hidden': 0,
  'Visible': 1
}


Object.freeze(LobbyTypeEnum);

export default LobbyTypeEnum;